import React, { useEffect } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fullwidthListElement } from 'commons/src/components/placeholder';
import CommonDeviceOverview from 'commons/src/features/devicePage/CommonDeviceOverview';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { ActionButton } from 'commons/src/models/menuModels';
import { fetchBuilding } from '../../actions/locationActions';
import { Store } from '../../reducers';
import { deviceActionButtons } from './DeviceMenuOptions';
import InsightInfoButtons from './InsightInfoButtons';

export const DeviceOverviewComponent = (): React.ReactElement => {
    const devicePageDevices = useSelector((state: Store) => state.devicePage.devices);
    const devicePageLoading = useSelector((state: Store) => state.devicePage.loading);
    const fetching = useSelector((state: Store) => state.devicePage.fetching);
    const buildings = useSelector((state: Store) => state.buildings.buildings);
    const { serialNumber } = useParams() as { serialNumber: string };
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const device = devicePageDevices[serialNumber] || {};
    const buildingId = device.locationId;
    const building = (device && buildings[buildingId as keyof typeof buildings]) || undefined;
    const deviceWithVirusRisk =
        device && device.sensors && device.sensors.some(sensor => sensor.type === SensorTypes.virusRisk);
    const deviceWithRadonSensor =
        device && device.sensors && device.sensors.some(sensor => sensor.type === SensorTypes.radonShortTermAvg);

    useEffect(() => {
        if (!building && buildingId) {
            dispatch(fetchBuilding(buildingId));
        }
    }, [buildingId]);

    const actionButtons: ActionButton[] = deviceActionButtons(
        deviceWithRadonSensor,
        device.deviceType,
        serialNumber,
        navigate
    );

    return (
        <CommonDeviceOverview actionButtons={actionButtons} timeZone={building?.timezone} serialNumber={serialNumber}>
            {deviceWithVirusRisk ? (
                <ReactPlaceholder ready={!devicePageLoading && !fetching} customPlaceholder={fullwidthListElement}>
                    <InsightInfoButtons sensor={SensorTypes.virusRisk} />
                </ReactPlaceholder>
            ) : (
                <div />
            )}
        </CommonDeviceOverview>
    );
};

export default DeviceOverviewComponent;
